export default __webpack_public_path__ + "static/media/background.85092f24.jpg";